import qs from 'qs';
import Url from 'url-parse';

const initEventRegistrantPage = () => {
    const queryParams = qs.parse(window.location.search.slice(1));

    if (!queryParams['event-view']) {
        return;
    }

    if (!window.location.hash) {
        window.location.href = `${window.location.href}#${queryParams['event-view']}`;
    };

    $('.nav__sidebar-anchors__list li a').on('click', event => {
        const { protocol, host, pathname } = window.location;
        const href = $(event.target).attr('href');

        if (!href.includes('http://') && !href.includes('https://')) {
            event.preventDefault();
            window.location.href = `${pathname}${href}`;
        }
    });
};

const transformDirectFileLinks = () => {
    $('a').each((linkIndex, link) => {
        if(['/member-only/'].some(href => link.href.includes(href)) && !link.href.includes('?file=')) {
            console.log('link updated');
            console.log('old', link.href);

            const url = Url(link.href);
            const queryParams = qs.parse(url.query.slice(1));
            delete queryParams.verify;
            url.set('query', `?${qs.stringify(queryParams)}`);
            link.href = url.href.replace(window.location.hostname + '/', window.location.hostname + '/?file=/');

            console.log('new', link.href);
            console.log('-----');
        }
    });
};

export const initLinks = () => {
    $(document).on('click', 'a[href], a[href] *', event => {
        event.stopPropagation();

        const $target = $(event.target);
        let $link = null;

        if (!$target.is('a[href]')) {
            $link = $target.closest('a[href]');
        } else {
            $link = $target;
        }

        if (!$link) {
            return;
        }

        const { hostname: linkHostname, href: linkHref, target: linkTarget } = $link.get(0);

        if (!linkHostname || !linkHref) {
            return;
        }

        // Open carousel videos in new window if user has not given cookie consent
        if ($link.hasClass('carousel-video') || $link.hasClass('card-video')) {
            if (!window.performanceCookieAccept) {
                event.preventDefault();
                window.open(linkHref, '_blank');
            }

            return;
        }

        // Open external links and members.inta.org in new window
        if ((linkHostname !== window.location.hostname && linkHostname !== 'members.inta.org')) {
            event.preventDefault();
            window.open(linkHref, '_blank');
            return;
        }

        // Open pdfs in new window
        if (linkHref.slice(linkHref.length - 4).toUpperCase() === '.PDF') {
            event.preventDefault();
            window.open(linkHref, '_blank');
            return;
        }
    });

    initEventRegistrantPage();
    transformDirectFileLinks();
};
